<template>
  <div class="form-group">
    <div class="form-input-column">
      <p
        v-if="formData.isloading"
        class="form-control"
      >
        loading ...
      </p>
      <input
        v-else
        id="company"
        v-model="formData.companyName"
        class="form-control-readonly"
        type="text"
        placeholder=" "
        readonly="readonly"
      >
      <label
        id="labelCompany"
        for="company"
        class="mt-5"
      >Company Name:</label>

      <ValidationProvider
        v-slot="{ errors }"
        class="form-input-column"
        name="ASN"
        rules="required|numeric"
      >
        <input
          id="asn"
          v-model="updateAsn"
          type="text"
          class="form-control"
          placeholder=" "
          @keyup="searchASN"
        >
        <label
          id="labelASN"
          for="asn"
        >
          ASN*
        </label>
        <span class="error">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </div>
</template>


<script>
import Exchange from "@/components/Exchange.vue";
import * as label from "./script/label.js";

import {
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import 'whatwg-fetch';

export default {
  name: "AsnFieldset",
  components: {
    ValidationProvider
  },
  data() {
    return {
      timeOut: null
    };
  },
  computed: {
    formData() {
      return this.$store.state.formData;
    },
    networkDetails() {
      return this.$store.state.networkDetails;
    },

    updateAsn: {
      get() {
        return this.$store.state.formData.asn;
      },
      set(value) {
        this.$store.commit("setFormDataAsn", value);
        label.labelChangeClass("labelASN", value);
      }
    }
  },
  methods: {
    searchASN() {
      var reg = /^\d+$/;
      if (this.formData.asn !== "") {
        if (reg.test(this.formData.asn)) {
          this.$store.state.formData.isloading = true;
          this.$store.state.formData.disableExchanges = true;
          this.$store.state.formData.noExchanges = false;
          label.labelChangeClass("labelCompany", this.formData.asn);
          clearTimeout(this.timeOut);
          this.timeOut = setTimeout(() => {
            this.$store.commit("laodNetworkData");
          }, 1000);
        }
      } else {
        label.labelChangeClass("labelCompany", this.formData.asn);
        this.$store.commit("resetSearch");
      }
    }
  }
};
</script>

<style lang="scss">
@import "./less/anx-button.scss";
@import "./less/anx-checkbox.scss";
@import "./less/anx-peering-form.scss";
</style>
